import TableTemplate from "../../TableTemplate/tableTemplate";
import { getDeltaHedgeExeLogsTable } from "../../../Requests/deltaHedgeExe";
import { ISearchParameters } from "../../../Interfaces/TableInterfaces";
import { CommonTableUI } from "../../TableTemplate/common";

interface IProps {
  id: number;
}

const DeltaHedgeExeTaskLogsTable = ({ id }: IProps) => {
  return (
    <TableTemplate<ISearchParameters, any>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI reports={reports} onAction={onAction} />
      )}
      getDataTable={getDeltaHedgeExeLogsTable}
      initialSearchParameters={{ id }}
    />
  );
};

export default DeltaHedgeExeTaskLogsTable;
